export const BonusTimeType = Object.freeze({
  SuddenDeath: 'SuddenDeath',
  Compensation: 'Compensation',
  Overtime: 'Overtime',
});

export default BonusTimeType;



// WEBPACK FOOTER //
// ./src/config/Constants.js